import type { AppDispatch, RootState } from '../../store';
import { equipmentReviewStatus } from '../../utils/equipmentGeometry';
import { translateInstances } from './equipmentSlice';

/**
 * Shift every selected equipment overlay by one delta. Resolving the selection
 * inside a thunk keeps callers (layout elements, the overlay itself) from having
 * to subscribe to the whole instances map just to drag a mixed group.
 *
 * `exclude` is the instance the pointer is actually holding: Konva already moves
 * that node natively, and its own drag-end commits the footprint.
 */
export const translateSelectedInstances =
  (step: { dx: number; dy: number }, options?: { exclude?: string | null }) =>
  (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();
    const ids = state.equipment.selectedInstanceIds.filter((id) => {
      if (id === options?.exclude) return false;
      const instance = state.equipment.instances[id];
      // Unreviewed DXF extracts are not draggable on their own either.
      return Boolean(instance) && equipmentReviewStatus(instance) !== 'potential';
    });
    if (ids.length === 0) return;
    dispatch(translateInstances({ ids, dx: step.dx, dy: step.dy }));
  };
